export const SIDEBAR_CONTENT = 'SIDEBAR_CONTENT';
export const SET_PROFILE = 'SET_PROFILE';
export const LOGOUT = 'LOGOUT';
export const ADD_TRIAL = 'ADD_TRIAL';


